module.exports = __webpack_public_path__ + "img/Dey.61d814a1.svg";